/**
 * EvaluationTypeSelection scene sagas
 *
 * @author Diogo Guedes <dguedes@ubiwhere.com>
 *
 */

import { takeLatest, put } from 'redux-saga/effects';
import { actions } from 'store/rootSlices';

function* onMountSaga() {
  yield put(actions.EvaluationTypeSelection.setLoading(false));
}

function* onUnmountSaga() {}

export default function* watcherSignin() {
  yield takeLatest('EvaluationTypeSelection/onMount', onMountSaga);
  yield takeLatest('EvaluationTypeSelection/onUnmount', onUnmountSaga);
}
